import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { ProcedureDto } from "../models/http/procedures/procedure-dto";
import { OdataResult } from "../models/http/odata-result";
import { IEnvironmentConfig } from "../../shared/interfaces/IEnvironmentConfig";

@Injectable({
  providedIn: "root",
})
export class ProcedureService {
  private _procedures$: Observable<ProcedureDto[]>;

  constructor(
    @Inject("ENV") private _env: IEnvironmentConfig,
    private _http: HttpClient
  ) {
    this._procedures$ = this._http
      .get<OdataResult<ProcedureDto[]>>(
        `${this._env.gatekeeperUrl}/odata/procedure`,
        { withCredentials: true }
      )
      .pipe(
        map((data) => data.value),
        shareReplay(1)
      );
  }

  public getProcedures(): Observable<ProcedureDto[]> {
    return this._procedures$;
  }
}
